/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import applicationFormStyle from "../../Form/applicationFormStyle";
import { scrollToAnchor } from "../../../theme/commonStyle";

const calculateSettlementCheckinStyle = {
  ...applicationFormStyle,
  default: {},
  grey: {
    backgroundColor: "background.contrast",
  },
  checkinHeading: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  superLabel: {
    paddingBottom: "0.25rem",
  },
  scrollToAnchor,
};

export default calculateSettlementCheckinStyle;
